<template>
<!-- 个人中心 新增档案页面 -->
  <div id="add-file">
    <!-- title -->
    <div class="top-title">
      <img src="../../assets/img/login-img/3-1档案-返回ic@2x.png" alt="" class="back-icon" @click="goBack">
      <p class="title-text siyuan-bold">新增档案</p>
    </div>
    <!-- end -->
    <!-- 阴影 -->
    <div class="shadow">
    </div>
    <!-- end -->
    <div class="content-box">
      <ul class="list-box">
        <li class="list-item">
          <span class="item-name item-flag">关系</span>
          <input readonly @click="showRelationSelect = true" :class="{'input-name':inputRelation===''}" type="name" placeholder="请选择" class="item-detail" v-model="relation">
        </li>
        <li class="list-item">
          <span class="item-name">姓名</span>
          <input :class="{'input-name':inputName===''}" type="name" placeholder="请输入姓名" class="item-detail" v-model="inputName">
        </li>
        <li class="list-item">
          <span class="item-name">性别</span>
          <div class="item-sex">
            <img :src="sexMan" alt="" class="sex-icon man" @click="selectMan">
            <img :src="sexMen" alt="" class="sex-icon" @click="selectMen">
          </div>
        </li>
        <li class="list-item">
          <span class="item-name">出生日期</span>
          <input readonly @click="showTimeSelect = true" type="text" :class="{'input-name':inputTime===''}" class="item-detail" v-model="inputTime" placeholder="请选择">
        </li>
        <li class="list-item">
          <span class="item-name">居住地</span>
          <input type="text" readonly v-model="inputArea" @click="showAreaSelect = true" :class="{'input-name':inputArea ===''}" class="item-detail" placeholder="请选择地址">
        </li>
      </ul>
    </div>
    <div class="bottom-wrapper">
      <div class="bottom-shadow">
      </div>
      <van-button size='large' type="primary" class='submit-button' @click="addFile">提交</van-button>
    </div>
    <!-- 时间弹出层 -->
    <van-popup v-model="showTimeSelect" position="bottom" :overlay="true">
      <van-datetime-picker v-model="currentDate" type="date" id="time-picker" :max-date='maxDate' :min-date="minDate" @cancel='showTimeSelect=false' @confirm='confirmTime' :visible-item-count=3 :item-height=66 />
    </van-popup>
    <!-- end -->
    <!-- 地址选择弹出层 -->
    <van-popup id="pop-area" v-model="showAreaSelect" position='bottom' :overlay="true">
      <van-area :area-list="areaList" value="440113" @cancel="showAreaSelect = false" @confirm="confirmArea" />
    </van-popup>
    <!-- 关系选择 -->
    <van-popup position='bottom' v-model="showRelationSelect">
      <ul class="relation-wrapper">
        <li class="relation-item" v-for="(item,index) in actions" :key="index" @click="onSelect(item)">
          <span>{{item.name}}</span>
        </li>
        <li class="relation-item cancel-button" @click="showRelationSelect = false">
          <span>取消</span>
        </li>
      </ul>
    </van-popup>
    <!-- end -->
  </div>
</template>

<script>
import areaList from '../../common/area.js'
import api from '@/api/index'
export default {
  data () {
    return {
      areaList,
      inputName: '',
      isMan: 'yes',
      inputTime: '1990-10-1',
      inputArea: '广东省广州市',
      inputRelation: 'self',
      relation: '本人',
      isDelect: false, // 控制删除icon状态
      showRelationSelect: false,
      showTimeSelect: false, // 控制时间弹出组件
      minDate: new Date(1900, 10, 1),
      maxDate: new Date(),
      showAreaSelect: false, // 控制地址选择弹出组件
      currentDate: new Date(1995, 6, 15),
      province: '广东省', // 省
      city: '广州市', // 市
      area: '', // 区 (‘self’,’couple’,’parent’,’children’,’other’)
      actions: [
        { name: '本人', value: 'self' },
        { name: '配偶', value: 'couple' },
        { name: '子女', value: 'children' },
        { name: '父母', value: 'parent' },
        { name: '其他', value: 'other' }
      ]
    }
  },
  methods: {
    goBack () {
      if (this.$route.query.from) {
        this.$router.push(this.$route.query.from)
      } else {
        this.$router.back(-1)
      }
    },
    selectMan () {
      this.isMan = 'yes'
    },
    selectMen () {
      this.isMan = 'no'
    },
    confirmTime (d) {
      this.inputTime =
        d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate()
      this.showTimeSelect = false
    },
    confirmArea (val) {
      this.inputArea = ''
      this.province = val[0].name
      this.city = val[1].name
      this.area = val[2].name
      val.map(item => {
        this.inputArea += item.name + ''
        this.showAreaSelect = false
      })
    },
    // 新增档案
    addFile () {
      if (this.judgeInfo()) {
        let url = api.addHealthRecords
        let params = {
          name: this.inputName,
          relation: this.inputRelation,
          sex: this.isMan === 'yes' ? 'm' : 'f',
          birthday: this.inputTime,
          province: this.province,
          city: this.city,
          area: this.area
        }
        this.fetch(url, params)
      }
    },
    fetch (url, params) {
      this.$http.post(url, this.$ObjToFd(params)).then(res => {
        if (res.data.code == 0) {
          this.$toast('提交成功')
          this.$router.back(-1)
        } else {
          this.$toast.fail(res.data.message)
        }
      })
    },
    onSelect (item) {
      this.relation = item.name
      this.showRelationSelect = false
      this.inputRelation = item.value
    },
    // 判断输入信息
    judgeInfo () {
      if (this.inputName === '') {
        this.$toast('姓名不能为空')
        return false
      } else if (this.inputName.length > 5) {
        this.$toast('姓名格式不对')
        return false
      } else {
        return true
      }
    }
  },
  computed: {
    sexMan () {
      return this.isMan === 'yes'
        ? require('../../assets/img/login-img/file-man-selected@2x.png')
        : require('../../assets/img/login-img/file-man-normal@2x.png')
    },
    sexMen () {
      return this.isMan === 'yes'
        ? require('../../assets/img/login-img/file-men-normal@2x.png')
        : require('../../assets/img/login-img/file-men-selected@2x.png')
    }
  }
}
</script>

<style lang="postcss">
#add-file {
  height: 100%;
  background-color: #fffffd;
  & .top-title {
    padding: 30px 0;
    position: relative;
    display: flex;
    justify-content: center;
    border-bottom: 1px solid #fffffd;
    & .back-icon {
      width: 17px;
      height: 34px;
      position: absolute;
      left: 30px;
    }
    & .title-text {
      font-size: 34px;
      font-family: "SourceHanSansCN Medium";
      font-weight: 400;
    }
  }
  & .shadow {
    width: 100%;
    height: 73px;
    image-size: 100%;
    background: url("../../assets/img/common-img/jianbian-shang@2x.png")
      repeat-x;
  }
  & .content-box {
    padding: 0 31px;
    & .list-box {
      & .item-flag {
      }
      & .list-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 144px;
        border-bottom: 1px solid #d7d7d7;
        position: relative;
        top: -60px;
        & .item-name {
          color: #666;
          font-size: 32px;
        }
        & .item-detail {
          font-size: 32px;
          color: #333;
          border: none;
          text-align: right;
          outline: none;
        }
        & .item-sex {
          display: flex;
          justify-content: space-between;
          & .sex-icon {
            width: 63px;
            height: 72px;
          }
          & .man {
            margin-right: 114px;
          }
        }
        & .input-name {
          color: #999;
          font-size: 24px;
        }
      }
    }
  }
  & .bottom-wrapper {
    position: absolute;
    bottom: 0;
    width: 100%;
    & .bottom-shadow {
      width: 100%;
      background: url("../../assets/img/common-img/jianbian-xia@2x.png")
        repeat-x;
      height: 73px;
    }
    & .submit-button {
      background: #fffffd;
      color: #37bd19;
      border: none;
      height: 88px;
      // position: absolute;
      // bottom: 0;
      font-size: 32px;
    }
  }
  & .relation-wrapper {
    & .relation-item {
      margin: 0 30px;
      height: 80px;
      font-size: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-bottom: 1px solid #d7d7d7;
    }
    & .relation-item:nth-last-child(2) {
      border: none;
    }
    & .cancel-button {
      border-top: 20px solid #d7d7d7;
      margin: 0;
    }
  }
  /* & #time-picker{ */
  /* background-color: red; */
  & .van-picker-column {
    font-size: 50px !important !important !important !important;
  }
  & .van-picker-column__item {
    font-size: 50px !important !important !important !important;
  }
  & .van-picker__confirm, & .van-picker__cancel {
    font-size: 30px;
    /* background-color: red !important; */
  }
  & .van-picker__toolbar {
    display: flex;
    align-items: center;
    /* background-color: red !important; */
  }
  & .van-picker__toolbar {
    height: 100px !important;
  }
  /* } */
  & .van-picker-column {
    & .van-picker-column__item {
      font-size: 32px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shenduUserInfo/SdAddFile.vue